import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export function StarFilled(props: IconProps = {}): JSX.Element {
  const { ...rest } = props;

  return (
    <SvgIcon name="StarFilled" {...rest}>
      <path
        d="M4.59 23L6.54 14.4961L0 8.77632L8.64 8.01974L12 0L15.36 8.01974L24 8.77632L17.46 14.4961L19.41 23L12 18.4908L4.59 23Z"
        fill="#20C26E"
      />
    </SvgIcon>
  );
}
